/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Title_EarlyInputs */

const en_us2_workout_after_title_early = /** @type {(inputs: Workout_After_Title_EarlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout ended`)
};

const pt_br2_workout_after_title_early = /** @type {(inputs: Workout_After_Title_EarlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino encerrado`)
};

const es_419_workout_after_title_early = /** @type {(inputs: Workout_After_Title_EarlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento terminado`)
};

const pt_pt2_workout_after_title_early = /** @type {(inputs: Workout_After_Title_EarlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino terminado`)
};

const fr_fr2_workout_after_title_early = /** @type {(inputs: Workout_After_Title_EarlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance arrêtée`)
};

const de_de2_workout_after_title_early = /** @type {(inputs: Workout_After_Title_EarlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training beendet`)
};

const it_it2_workout_after_title_early = /** @type {(inputs: Workout_After_Title_EarlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento terminato`)
};

/**
* | output |
* | --- |
* | "Workout ended" |
*
* @param {Workout_After_Title_EarlyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_title_early = /** @type {((inputs?: Workout_After_Title_EarlyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Title_EarlyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_title_early(inputs)
	if (locale === "es-419") return es_419_workout_after_title_early(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_title_early(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_title_early(inputs)
	if (locale === "de-DE") return de_de2_workout_after_title_early(inputs)
	if (locale === "it-IT") return it_it2_workout_after_title_early(inputs)
	return en_us2_workout_after_title_early(inputs)
});
export { workout_after_title_early as "workout-after.title_early" }